import { queries } from "lib/build/dashboards/ktx/queries";
import { Origin } from "lib/build/events";
import { StatusByNephrologist } from "lib/build/forms/ktx/patientCondition";

import { useLastEventByQuery } from "src/features/events";

export function useNephrologistOpinion(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const event = useLastEventByQuery<string>(queries.statusByNephrologist);
	if (event === undefined) {
		return { value: "-" };
	}

	const opinion =
		event.value === StatusByNephrologist.TRANSPLANTABLE ? "T" : "NT";

	return {
		value: opinion,
		timestamp: event.timestamp,
		origin: event.origin
	};
}
